var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklesSoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkles-soft"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.5 13C14.5987 13.4243 11.9243 16.0987 11.5 21C11.0578 16.0225 8.39737 13.5547 3.5 13C8.47478 12.4262 10.9262 9.97478 11.5 5C12.0547 9.89737 14.5225 12.5578 19.5 13Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M19.3864 2.34512C19.3642 2.14869 19.1981 2.0002 19.0004 2C18.8027 1.9998 18.6363 2.14794 18.6137 2.34433C18.5082 3.25861 18.2367 3.88584 17.8113 4.31127C17.3858 4.7367 16.7586 5.00822 15.8443 5.11367C15.6479 5.13632 15.4998 5.30271 15.5 5.5004C15.5002 5.69809 15.6487 5.86417 15.8451 5.88642C16.7439 5.98823 17.3855 6.25969 17.8217 6.68804C18.2556 7.11407 18.5322 7.74041 18.6126 8.64552C18.6305 8.84634 18.7988 9.00023 19.0004 9C19.202 8.99977 19.3701 8.84551 19.3874 8.64465C19.4645 7.75483 19.7409 7.11438 20.1776 6.67764C20.6144 6.24091 21.2548 5.96446 22.1446 5.88744C22.3455 5.87005 22.4998 5.70205 22.5 5.50044C22.5002 5.29883 22.3463 5.13048 22.1455 5.11264C21.2404 5.03224 20.6141 4.75557 20.188 4.3217C19.7597 3.88545 19.4882 3.24394 19.3864 2.34512Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesSoft);
export default __webpack_public_path__ + "static/media/sparkles-soft.de1dba2b141cf11eb69b512c631f95d1.svg";
export { ForwardRef as ReactComponent };